import axios from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as errors from 'smg/errors';
import Modal from 'smg/modal';
import * as template from 'smg/template';
import * as toast from 'smg/toast';

export default function main() {
    const form = document.querySelector('#form') as HTMLFormElement;
    const fieldset = document.querySelector('fieldset') as HTMLFieldSetElement;
    const submit = document.querySelector('button') as HTMLButtonElement;
    const email = document.querySelector('#email') as HTMLInputElement;

    form?.addEventListener('submit', e => {
        e.preventDefault();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(submit);

        axios.post('/password-resets', {
            'email': email.value,
        }).then(() => {
            const body = template.Clone('#reset-password-sent-template');
            const sentEmail = body.querySelector('#modal-email') as HTMLElement;
            sentEmail.textContent = email.value;

            new Modal({
                title: 'Check your email',
                body,
                cancelText: 'Close',
                outsideClosable: false,
            });
        }).catch(err => errors.HandleRequestError(err, form, msg => toast.Error(msg))).finally(() => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(submit);
        });
    });
}